function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Path } from "react-native-svg";

var _ref = /*#__PURE__*/React.createElement(G, {
  stroke: "#FFF",
  strokeWidth: 1.5,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement(Path, {
  d: "M4.32 16.745c.704 6.937 6.562 12.35 13.684 12.35 7.117 0 12.97-5.402 13.683-12.33"
}), /*#__PURE__*/React.createElement(Path, {
  d: "M26.816 19.692l4.871-2.927 2.928 4.871m-2.998-8.466C30.911 6.234 25.054.82 17.931.82 10.815.82 4.96 6.223 4.248 13.15"
}), /*#__PURE__*/React.createElement(Path, {
  d: "M9.119 10.224l-4.871 2.927L1.32 8.279"
}));

function SvgIconMenuKastboxActive(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 30
  }, props), _ref);
}

export default SvgIconMenuKastboxActive;